import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/vevo/mascot_peek.png'


const _hoisted_1 = {
  key: 1,
  class: "pa-3"
}
const _hoisted_2 = {
  class: "d-flex align-center",
  style: {"gap":"0.5rem"}
}
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = { class: "text-caption text-grey" }
const _hoisted_5 = { class: "d-flex align-center mb-2" }
const _hoisted_6 = { class: "text-subtitle-2 font-weight-bold" }
const _hoisted_7 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_8 = {
  key: 0,
  class: "ai-report-content text-body-2"
}
const _hoisted_9 = {
  class: "d-flex flex-column mt-3",
  style: {"gap":"0.5rem"}
}
const _hoisted_10 = { class: "text-body-2 mb-1" }
const _hoisted_11 = { class: "text-caption text-grey-darken-2 mb-1 font-weight-bold" }
const _hoisted_12 = { class: "text-caption" }
const _hoisted_13 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_14 = { class: "text-caption" }
const _hoisted_15 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_16 = { class: "text-subtitle-1 font-weight-bold mb-2" }
const _hoisted_17 = { class: "text-body-2" }
const _hoisted_18 = { class: "text-caption" }
const _hoisted_19 = {
  key: 1,
  class: "my-2"
}
const _hoisted_20 = { class: "mt-1 text-body-2" }
const _hoisted_21 = {
  class: "d-flex mt-2",
  style: {"gap":"0.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_ai_report_status_chip = _resolveComponent("ai-report-status-chip")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          style: {"position":"absolute"},
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "large",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content","font-size":"14px"} }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('aiReport.title')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer)
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        (_ctx.isFetching)
          ? (_openBlock(), _createBlock(_component_v_progress_linear, {
              key: 0,
              indeterminate: "",
              color: "primary"
            }))
          : _createCommentVNode("", true),
        (_ctx.detail)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.detail.lastName) + " " + _toDisplayString(_ctx.detail.firstName), 1),
                _createVNode(_component_ai_report_status_chip, {
                  status: _ctx.detail.status
                }, null, 8, ["status"])
              ]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiReport.detail.subtitle', { className: _ctx.detail.className, ageLabel: _ctx.detail.ageLabel, year: _ctx.detail.businessYear, monthsLabel: _ctx.detail.monthsLabel })), 1),
              (_ctx.detail.dataCoverageMonths.length < 3)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    variant: "outlined",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('aiReport.detail.coverageWarning', { months: _ctx.formatCoverage(_ctx.detail.dataCoverageMonths) })), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "pa-4 mt-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "VEVO",
                      class: "mr-1",
                      style: {"width":"24px","height":"24px","object-fit":"contain"}
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('aiReport.detail.contentTitle')), 1),
                    _createVNode(_component_v_spacer),
                    (_ctx.detail.content)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('aiReport.detail.charCount', { count: _ctx.contentLength })), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.detail.content)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.detail.content), 1))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "info",
                        variant: "outlined",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('aiReport.detail.notGenerated')), 1)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.detail.status === 'draft')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      color: "primary",
                      variant: "flat",
                      block: "",
                      loading: _ctx.isPublishing,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setStatus('published')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-publish", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.detail.publish')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.status === 'published')
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      variant: "outlined",
                      block: "",
                      loading: _ctx.isPublishing,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setStatus('draft')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { start: "" }, {
                          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                            _createTextVNode("mdi-undo", -1)
                          ]))]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.detail.revertToDraft')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (_ctx.detail.status === 'draft')
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 2,
                      disabled: !_ctx.noData,
                      location: "top",
                      text: _ctx.$t('aiReport.detail.noDataTooltip')
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _mergeProps(props, { class: "d-block" }), [
                          _createVNode(_component_v_btn, {
                            variant: "outlined",
                            block: "",
                            disabled: _ctx.noData || _ctx.isRegenerating,
                            onClick: _ctx.openRegenerate
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { start: "" }, {
                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                  _createTextVNode("mdi-refresh", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.detail.regenerate')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ], 16)
                      ]),
                      _: 1
                    }, 8, ["disabled", "text"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isRegenerating && !_ctx.regenerateOpen)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    variant: "outlined",
                    color: "primary",
                    icon: "mdi-progress-clock",
                    density: "compact",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('aiReport.detail.regeneratingInProgress')), 1),
                      _createVNode(_component_v_progress_linear, {
                        indeterminate: "",
                        color: "primary",
                        height: "6",
                        rounded: ""
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card, {
                variant: "outlined",
                class: "pa-3 mt-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('aiReport.detail.operationLog')), 1),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.$t('aiReport.detail.lastGenerated', { date: _ctx.formatDateTime(_ctx.detail.lastGeneratedAt) })) + " ", 1),
                    (_ctx.detail.lastGeneratedBy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, " / by " + _toDisplayString(_ctx.detail.lastGeneratedBy), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.$t('aiReport.detail.lastPublished', { date: _ctx.formatDateTime(_ctx.detail.lastPublishedAt) })) + " ", 1),
                    (_ctx.detail.lastPublishedBy)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " / by " + _toDisplayString(_ctx.detail.lastPublishedBy), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (_ctx.detail.status === 'published')
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 2,
                    type: "warning",
                    variant: "outlined",
                    density: "compact",
                    class: "mt-3 text-caption"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('aiReport.detail.publishedNotice')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.regenerateOpen,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.regenerateOpen) = $event)),
      "max-width": "420",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('aiReport.regenerateDialog.title')), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('aiReport.regenerateDialog.description', { name: _ctx.detail ? `${_ctx.detail.lastName} ${_ctx.detail.firstName}` : '' })), 1),
            _createVNode(_component_v_alert, {
              variant: "outlined",
              color: "primary",
              icon: "mdi-information-outline",
              density: "compact",
              class: "my-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('aiReport.regenerateDialog.translateNotice')), 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.regenerateDialog.asyncNotice')), 1)
                ])
              ]),
              _: 1
            }),
            (_ctx.canTranslate)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.regenerateMode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.regenerateMode) = $event)),
                    class: "mb-1",
                    density: "compact",
                    "hide-details": "",
                    disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('aiReport.regenerateDialog.modeSimple'),
                        value: "simple"
                      }, null, 8, ["label"]),
                      _createVNode(_component_v_radio, {
                        label: _ctx.$t('aiReport.regenerateDialog.modeTranslate'),
                        value: "translate"
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"]),
                  (_ctx.regenerateMode === 'translate')
                    ? (_openBlock(), _createBlock(_component_v_select, {
                        key: 0,
                        modelValue: _ctx.selectedLanguage,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                        items: _ctx.languageItems,
                        "item-title": "label",
                        "item-value": "code",
                        label: _ctx.$t('aiReport.regenerateDialog.targetLanguage'),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "",
                        class: "mb-2",
                        disabled: !!_ctx.activeBatch && _ctx.activeBatch.status === 'processing'
                      }, null, 8, ["modelValue", "items", "label", "disabled"]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.activeBatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_v_progress_linear, {
                    indeterminate: _ctx.activeBatch.status === 'processing',
                    "model-value": _ctx.activeBatch.status === 'completed' ? 100 : 0,
                    color: "primary",
                    height: "8",
                    rounded: ""
                  }, null, 8, ["indeterminate", "model-value"]),
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.activeBatch.status === 'processing')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('aiReport.regenerateDialog.processing')), 1)
                        ], 64))
                      : (_ctx.activeBatch.status === 'completed')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_v_icon, {
                              size: "small",
                              color: "success"
                            }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode("mdi-check-circle", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.regenerateDialog.completed')), 1)
                          ], 64))
                        : (_ctx.activeBatch.status === 'failed')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "red"
                              }, {
                                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                  _createTextVNode("mdi-alert-circle", -1)
                                ]))]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('aiReport.regenerateDialog.failed')), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.closeRegenerate,
                disabled: _ctx.isStarting
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.activeBatch && _ctx.activeBatch.status === 'completed' ? _ctx.$t('common.close') : _ctx.$t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              (!_ctx.activeBatch || _ctx.activeBatch.status === 'failed')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "primary",
                    variant: "flat",
                    loading: _ctx.isStarting,
                    disabled: _ctx.startRegenerateDisabled,
                    onClick: _ctx.startRegenerate
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.regenerateMode === 'translate' ? _ctx.$t('aiReport.regenerateDialog.translate') : _ctx.$t('aiReport.regenerateDialog.start')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}